export enum SoundChannelEvent {
    MUTE = 'mute',
    UNMUTE = 'unmute'
}
